// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1yEoG","col":"styles_col__1NC8g"};